"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = exports.Label = exports.Button = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _getButtonVariantStyle = require("../../utils/getButtonVariantStyle");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Button = exports.Button = _styledComponents["default"].button.withConfig({
  displayName: "Buttonstyle__Button",
  componentId: "sc-oudur2-0"
})(function (_ref) {
  var _ref$theme = _ref.theme,
    breakpoint = _ref$theme.breakpoint,
    color = _ref$theme.color,
    shadow = _ref$theme.shadow,
    border = _ref$theme.border,
    spacing = _ref$theme.spacing,
    font = _ref$theme.font,
    fullWidth = _ref.fullWidth,
    small = _ref.small,
    variant = _ref.variant,
    loading = _ref.loading;
  return _objectSpread(_objectSpread({
    transition: '0.1s',
    background: 'transparent',
    display: 'inline-block',
    border: 'none',
    borderRadius: border.radius.lg,
    width: fullWidth ? '100%' : 'auto',
    cursor: 'pointer',
    outline: 'none',
    padding: small ? spacing.squish.sm : "".concat(spacing.inline['4xs'], " ").concat(spacing.inline.xs),
    fontFamily: "".concat(font.family.base, ", Roboto, sans-serif !important"),
    fontSize: small ? 12 : 14,
    textAlign: 'center',
    textDecoration: 'none',
    position: 'relative',
    pointerEvents: loading ? 'none' : 'auto',
    minWidth: fullWidth ? 'auto' : '148px'
  }, (0, _getButtonVariantStyle.getButtonVariantStyle)({
    variant: variant,
    color: color,
    shadow: shadow
  })), {}, _defineProperty(_defineProperty({
    svg: {
      fill: 'currentColor',
      width: '1em',
      height: '1em',
      top: '.125em',
      position: 'relative'
    }
  }, breakpoint.md(), {
    fontSize: small ? 14 : 16
  }), ':disabled, &[aria-disabled="true"]', {
    pointerEvents: 'none',
    opacity: '0.5'
  }));
});
var Label = exports.Label = _styledComponents["default"].span.withConfig({
  displayName: "Buttonstyle__Label",
  componentId: "sc-oudur2-1"
})(function (_ref2) {
  var hide = _ref2.hide;
  return {
    color: hide && 'transparent'
  };
});
var wave = (0, _styledComponents.keyframes)(["from{opacity:0.4;}to{opacity:1;}"]);
var marginBefore = function marginBefore(theme) {
  return "-".concat(theme.spacing.inline['6xs'], " -").concat(theme.spacing.inline['2xs']);
};
var margin = function margin(theme) {
  return "-".concat(theme.spacing.inline['6xs'], " -").concat(theme.spacing.inline['6xs']);
};
var marginAfter = function marginAfter(theme) {
  return "-".concat(theme.spacing.inline['6xs'], " ").concat(theme.spacing.inline['4xs']);
};

// Made with template literals because Keyframes don't work with object syntax
var Loading = exports.Loading = _styledComponents["default"].span.withConfig({
  displayName: "Buttonstyle__Loading",
  componentId: "sc-oudur2-2"
})(["span,span:before,span:after{background:currentColor;border-radius:50%;width:", ";height:", ";position:absolute;top:50%;left:50%;}span:before{content:'';margin:", ";animation:", " 0.5s 0s linear infinite alternate-reverse;}span{margin:", ";animation:", " 0.5s 0.2s linear infinite alternate-reverse;}span:after{content:'';margin:", ";animation:", " 0.5s 0.4s linear infinite alternate-reverse;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing.inline['5xs'];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacing.inline['5xs'];
}, function (_ref5) {
  var theme = _ref5.theme;
  return marginBefore(theme);
}, wave, function (_ref6) {
  var theme = _ref6.theme;
  return margin(theme);
}, wave, function (_ref7) {
  var theme = _ref7.theme;
  return marginAfter(theme);
}, wave);